export default "__VITE_ASSET__DrBG6RpN__"